import { OverlayConfig } from '@angular/cdk/overlay';

export class PromptConfig extends OverlayConfig {
	successLabel?: string;
	successType?: string;
	cancelLabel?: string;
	buttonsPosition?: 'start' | 'end';
}
